/* eslint-disable max-lines-per-function */
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@e2n/ui';
import { Standort } from '@/features/standortContext/entities/standort';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { faCheck, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';

export function StandorteDropdown() {
  const { currentStandort, updateStandort, standorte } = useStandortContext();
  const { t } = useTranslation();

  function getDisplayName(standort: Standort) {
    let displayName = '';
    if (standort.storeNummer && standort.storeNummer.length > 0) {
      displayName += standort.storeNummer + ' - ';
    }
    displayName += standort.name;
    return displayName;
  }

  return standorte.length < 1 ? (
    <></>
  ) : (
    <TooltipProvider>
      <DropdownMenu>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button className="size-8" variant="ghost">
                <FontAwesomeIcon
                  icon={faLocationDot}
                  className="size-4 text-neutrals-800"
                />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent className="max-w-64">
            {t('general.navigation.standort.standortAuswählen')}
          </TooltipContent>
        </Tooltip>
        <DropdownMenuContent
          className="max-w-64 p-3 max-h-72"
          align="start"
          onCloseAutoFocus={(e) => e.preventDefault()}>
          {standorte.map((standort) => (
            <Fragment key={standort.id}>
              <DropdownMenuItem
                className="p-2 text-neutrals-900"
                onClick={() => updateStandort(standort)}
                asChild>
                <div className="flex justify-between items-center">
                  <div className="truncate">{getDisplayName(standort)}</div>
                  {standort.id === currentStandort.id && (
                    <FontAwesomeIcon
                      className="text-primary-blue-600"
                      icon={faCheck}
                    />
                  )}
                </div>
              </DropdownMenuItem>
              <DropdownMenuSeparator className="last:hidden m-0" />
            </Fragment>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </TooltipProvider>
  );
}
